<script>
export default {
  props: {
    isChecked: {
      type: Boolean,
      default: false,
    },
    fieldId: {
      type: String,
      default: '',
      required: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    checkedlbl: {
      type: String,
      default: 'On',
    },
    uncheckedlbl: {
      type: String,
      default: 'Off',
    },
  },
  methods: {
    toggleEvent(isChecked) {
      this.$emit('toggleEvent', isChecked)
    },
  },
}
</script>
<template>
  <div>
    <toggle-button
      :id="fieldId"
      :value="isChecked"
      :sync="true"
      v-bind="$attrs"
      :disabled="isDisabled"
      :labels="{ checked: checkedlbl, unchecked: uncheckedlbl }"
      @change="toggleEvent"
    >
    </toggle-button>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
